import { render, staticRenderFns } from "./edit-profile.vue?vue&type=template&id=07e7069a&scoped=true"
import script from "./edit-profile.vue?vue&type=script&lang=js"
export * from "./edit-profile.vue?vue&type=script&lang=js"
import style1 from "./edit-profile.vue?vue&type=style&index=1&id=07e7069a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e7069a",
  null
  
)

export default component.exports